import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, signupDataState, SignupState } from '../index';

export const selectSignupState = createFeatureSelector<SignupState>(featureKey);

export const selectDataState = createSelector(
  selectSignupState,
  (state: SignupState): signupDataState => {
      return state.data;
  }
)
  
export const selectUser = createSelector(
  selectDataState,
  (state: signupDataState) => {
    return _.get(state, 'user', null);
  }
)

export const selectCoupon = createSelector(
  selectDataState,
  (state: signupDataState) => {
    return _.get(state, 'coupon', null);
  }
)

export const selectInvoices = createSelector(
  selectDataState,
  (state: signupDataState) => {
    return _.get(state, 'invoices', []);
  }
)

export const selectUserError = createSelector(
  selectDataState,
  (state: signupDataState) => {
    return _.get(state, 'userError', null);
  }
)


export const selectAddInfoError = createSelector(
  selectDataState,
  (state: signupDataState) => {
    return _.get(state, 'addInfoError', null);
  }
)

export const selectVereficationOrgError = createSelector(
  selectDataState,
  (state: signupDataState) => {
    return _.get(state, 'vereficationOrgError', null);
  }
)

export const selectCouponError = createSelector(
  selectDataState,
  (state: signupDataState) => {
    return _.get(state, 'couponError', null);
  }
)

